import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHygineTasksApprovalData } from "../../../redux/hygiene-reducers/hygieneSlice";
import CommonStructured from "../../common-components/CommonStructured";
import CmnFilters from "../../lead-management/common/CmnFilters";
import TaskApprovalListings from "./TaskApprovalListings";
// import { currentDateOfTheMonth } from "../../common-data/Converts";

const AllTasksApproval = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { hygineTaskApprovalLoading } = useSelector((state) => state.hygiene);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStartDate: "",
    selectedHygineCategory: "",
    selectedTaskPriority: "",
    selAssignee:
      !isAdmin && !isManagerRole
        ? {
            lavel: userInfoData?.account_type,
            value: userInfoData?.account_type,
          }
        : "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: pageLimit || 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    task_date: allFilters.selectedStartDate || "",
    category: allFilters.selectedHygineCategory?.value || "",
    priority: allFilters.selectedTaskPriority?.value || "",
    stakeholders: allFilters.selAssignee?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygineTasksApprovalData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTasks(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      task_date: allFilters.selectedStartDate || "",
      category: allFilters.selectedHygineCategory?.value || "",
      priority: allFilters.selectedTaskPriority?.value || "",
      stakeholders: allFilters.selAssignee?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedHygineCategory,
    allFilters.selectedTaskPriority,
    allFilters.selAssignee,
    allFilters.isActive,
    allFilters.selectedGym,
    allFilters.selectedStartDate,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <CommonStructured
        pageHeading={"Daily Operation Checklist Breakdown Request"}
        isReload={() => {
          getHygieneTasks(filters);
        }}
      />

      <CmnFilters
        from={"hygine-tasks-approval"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={hygineTaskApprovalLoading}
      />

      <TaskApprovalListings
        userInfoData={userInfoData}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        callFunction={() => {
          getHygieneTasks(filters);
        }}
      />
    </>
  );
};

export default AllTasksApproval;
